import { toast } from "react-toastify";

import CargillBranchClient from "../../../api/cargill-branch";

toast.configure();
export const cargillBranches = {
  state: {
    branches: [],
    loading: false,
  },
  reducers: {
    setBranches(state, payload) {
      return {
        ...state,
        branches: payload,
      };
    },
    loading(state, payload) {
      return {
        ...state,
        loading: payload.loading,
      };
    },
    clearStore() {
      return {};
    },
  },
  effects: (dispatch) => ({
    async loadAsync(payload, rootState) {
      try {
        this.loading({ loading: true });
        const { data } = await CargillBranchClient.getAll();
        this.setBranches(data);
        this.loading({ loading: false });
        return {
          success: true,
          message: "Branches listadas com sucesso!",
        };
      } catch (error) {
        const errorMessage =
          error.response && error.response.data
            ? error.response.data
            : "Erro ao listar branches.";
        toast.error(`Ops :( Algo deu errado!\n${errorMessage}`);
        this.loading({ loading: false });
        return {
          success: false,
          message: errorMessage,
        };
      }
    },

    async loadAvailableByProductIdAsync(payload, rootState) {
      const { productId, loadTypeId } = payload;
      try {
        const res = await CargillBranchClient.getAvailableByProductId(
          productId,
          loadTypeId
        );
        const { data } = res;

        this.setBranches(data);
      } catch (error) {
        await toast.error("Algo deu errado :( !", {
          position: "top-right",
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    },

    async loadAvailableByPlantIdAsync(payload, rootState) {
      try {
        const { idPlant, idLoadType } = payload;
        const { data } = await CargillBranchClient.getAvailableByPlantId(
          idPlant,
          idLoadType
        );
        this.setBranches(data);
      } catch (error) {
        await toast.error("Algo deu errado :( !", {
          position: "top-right",
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    },
  }),
};
